import { render } from "./GroupEvaluations.vue?vue&type=template&id=e8d6e442"
import script from "./GroupEvaluations.vue?vue&type=script&lang=js"
export * from "./GroupEvaluations.vue?vue&type=script&lang=js"

import exportComponent from "F:\\online.ug\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__